export function setFieldValidity($el: JQuery, isValid: boolean) {
	if ($el.data('is-valid') === isValid) {
		return;
	}

	$el.data('is-valid', isValid);

	if ($el.hasClass('form-control')) {
		$el.removeClass('is-valid is-invalid')
			.addClass(isValid ? 'is-valid' : 'is-invalid');
	}

	$el.trigger('validityUpdate');
}

export function isFieldValid($el: JQuery): boolean {
	return $el.data('is-valid');
}

export function getQueryParamFromUrl(param: string, url: string = window.location.href): string {

	const indexOf = url.toLowerCase().indexOf(param.toLowerCase());

	if (indexOf >= 0) {
		const paramName = url.substring(indexOf, indexOf + param.length);
		return new URL(url).searchParams.get(paramName);
	}

	return '';

}

export function getUrlWithoutParam(param: string, url: string = window.location.href): string {
	const newUrl = new URL(url);
	newUrl.searchParams.delete(param);
	return newUrl.toString();
}

export function togglePassword($elem) {
	$elem.children().toggleClass("fa-eye fa-eye-slash");
	var input = $($elem.attr("toggle"));
	if (input.attr("type") == "password") {
	  input.attr("type", "text");
	} else {
	  input.attr("type", "password");
	}
  }
